var Vendd = (function(Vendd) {
    'use strict';

    Vendd.Control = (function(Control) {

        Control.GetType = function(control) {
            return control.nodeName.toLowerCase() + '.' + control.type;
        };

        Control.GetValue = function (control, dataType) {
            var controlType = Control.GetType(control);

          

            if (control && typeof (dataType) === 'string') {
                switch (dataType) {
                case 'string':
                    return control.value;
                case 'number':
                    return isNaN(control.value) ? "" : Number(control.value);
                case 'boolean':
                    return control.checked;
                case 'object':
                    return control.value;
                default:
                    return control.value;
                }
            }
        };

        Control.SetValue = function(control, value) {

            var controlType = Control.GetType(control);


            if (value === undefined) {
                if (!control.type) {
                        control.innerText = "";
                } else {
                    switch (controlType) {
                        case 'input.radio':

                        case 'input.file':
                            control.filename = "";
                            break;
                        case 'input.checkbox':

                            var isChecked = false;

                            break;
                        default:
                            control.value = "";
                            break;
                    };
                };
                return ;
            }

            if (!control.type) {
                if (Vendd.Helpers.IsHTML(value))
                    control.innerHTML = value;
                else if (control.innerText) {
                    control.innerText = value;
                } else {
                    control.innerHTML = value;
                }
            } else {
                switch (controlType) {
                    case 'input.radio':
                        break;
                    case 'input.file':
                        break;
                    case 'input.checkbox':            

                    var isChecked = false;

                    if (typeof value === 'string')
                        isChecked = control.value === value;

                    if (typeof value === 'boolean')
                        isChecked = value;


                    control.checked = isChecked;
                    break;
                default:
                    control.value = value;
                    break;
                };
            };
        };

        Control.SetVisibility = function (control, value) {

            var $control = $(control);

            if (value === undefined) {
                $control.hide();
                return;
            }

            if (typeof value === "boolean") {

                if (value) {
                    $control.show();
                } else {
                    $control.hide();
                }

                return;
            }

            if (typeof value === "string") {

                if (value.length > 0) {
                    $control.show();
                } else {
                    $control.hide();
                }

                return;
            }


        };

        return Control;

    })(Vendd.Control || {});

    Vendd.ControlHelpers = (function (ControlHelpers) {

        ControlHelpers.HandleError = function (control, observableOldValue, exception) {

           
            control.value = observableOldValue;
            control.focus();
            control.select();
            /*throw exception;*/
        };

        return ControlHelpers;
    })(Vendd.ControlHelpers || {});

    return Vendd;

})(Vendd || {});